import hyperdom from 'hyperdom'

export default class Navigation {
  constructor ({
    availableTabs,
    bookingComplete,
    isNavigable,
    getTabName,
    navigateTab,
  }) {
    this.availableTabs = availableTabs
    this.bookingComplete = bookingComplete
    this.isNavigable = isNavigable
    this.getTabName = getTabName
    this.navigateTab = navigateTab
  }

  renderNavigation (currentTab, forMobile) {
    if (!currentTab) return
    const tabIds = this.availableTabs().map(tab => tab.id)
    const currentTabIndex = tabIds.indexOf(currentTab.id)

    return <ul className={['main-menu__tabs', {'main-menu--mobile' : forMobile}]}>
      {
        this.availableTabs().map((tab, tabIndex) => {
          const tabId = tab.id
          if (tabId !== 'confirmation' && !this.bookingComplete()) {
            const isVisited = tabIndex < currentTabIndex
            const isNavigable = this.isNavigable(currentTabIndex, tabIndex)
            return [
              <li
                data-test={tab.dataTest}
                data-item-type='General Interaction'
                data-item-name={`${tabId}-tab`}
                className={[
                  'main-menu__item',
                  `${tabId}-tab`,
                  {
                    'active': tabId === currentTab.id,
                    'navigable': isNavigable,
                    'main-menu--mobile' : forMobile,
                  }]}
                onclick={() => isNavigable && this.navigateTab({tabId, currentTabIndex, tabIndex})}>
                <span className={['main-menu__step-number',
                  {
                    'navigable': isNavigable,
                    'visited' : isVisited && tabId !== currentTab.id,
                    'main-menu--mobile' : forMobile,
                  }]}>
                  {
                    !isVisited
                      ? [<span>{tabIndex + 1}</span>, <span className="step-number-dot">.</span>]
                      : undefined
                  }
                </span>
                <span className="main-menu__step-text">{this.getTabName(tab.id)}</span>
              </li>,
              <span className={[{
                'icon-thin-right-arrow main-menu__step-arrow': tabId !== 'payment',
                'main-menu--mobile': forMobile,
              }]}/>,
            ]
          }
        })
      }
    </ul>
  }
}
